import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { ProjectCustomerConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { ProjectCustomersService } from './api/projectCustomers.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ProjectCustomerApiModule {
    public static forRoot(configurationFactory: () => ProjectCustomerConfiguration): ModuleWithProviders<ProjectCustomerApiModule> {
        return {
            ngModule: ProjectCustomerApiModule,
            providers: [ { provide: ProjectCustomerConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ProjectCustomerApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ProjectCustomerApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
